import projection from '../generated/pwd217f1.json';
import { AcceptanceManifest } from '../types';
export const pwd217f1AcceptanceManifest = projection as AcceptanceManifest;
